import React from "react";
import MainEducation from "../../Component/Products/education";

const Education = () => {
	return <MainEducation />;
};

export default Education;
